import { Flex } from "@radix-ui/themes";
import { t } from "i18next";
import React, { Dispatch, SetStateAction } from "react";
import { Button } from "../../../ui/Button";
import { Popover, PopoverTrigger, PopoverContent } from "../../../ui/Popover";
import { SortingState } from "@tanstack/react-table";
import TableSortingCategory from "../../../components/Filters/TableSortingCategory";
import { Tab, useTabsStore } from "../../../stores/TabsStore";
import { TbX } from "react-icons/tb";
import { Separator } from "../../../ui/Separator";

type Props = {
  sortingState: [SortingState, Dispatch<SetStateAction<SortingState>>];
  sortingColumns: {categoryName: string, columnId: string}[]
  tab: Tab;
};

const Sorting = ({ sortingState, tab, sortingColumns }: Props) => {
  const [sorting, setSorting] = sortingState; // Общий фильтр
  const addFilters = useTabsStore((store) => store.addFilters);

  const changeSorting = (newState: SortingState) => {
    addFilters(tab.id, { ...tab.options?.filters, sorting: newState });
    setSorting(newState);
  };

  const state: [SortingState, Function] = [sorting, changeSorting];

  const cleanSorting = (e: React.MouseEvent<SVGElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {
    e.stopPropagation();
    addFilters(tab.id, { ...tab.options?.filters, sorting: [] });
    setSorting([]);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="flex flex-none items-center">
          <Button variant="outline" size="datepicker" className="px-0 items-center">
            <span className="px-2">{t("sorting")}</span>
            {sorting.length > 0 ? <span className="border-l w-6 bg-muted h-full p-0.5 flex items-center justify-center hover:bg-destructive hover:text-white rounded-r-md"><TbX className="cursor-pointer" onClick={(e) => cleanSorting(e)} /></span> : <></>}
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent className="px-0 py-0 text-base" align="start">
        <div className="flex items-center justify-between px-3 py-2 h-10">
          <div className="leading-6 font-semibold">{t("sorting")}</div>
          <Button variant="outline" size="xs" type="button" onClick={(e) => cleanSorting(e)}>
            {t("clear")}
          </Button>
        </div>
        <Separator/>
        <div className="px-3 space-y-1 py-3">
          {sortingColumns.map((category) => (
            <TableSortingCategory
              key={category.columnId}
              categoryName={category.categoryName}
              columnId={category.columnId}
              sortingState={state}
            />
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default Sorting;
